import { onBeforeUnmount, onMounted } from 'vue';

import { analyticsEventsLib } from '@/shared/lib';

const SCROLL_DEPTHS = [25, 50, 75, 100] as const;

const getScrollDepthPercent = () => {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight;
  if (docHeight <= 0) return 100;
  return Math.round(((scrollTop + window.innerHeight) / docHeight) * 100);
};

const getScrolledBlocks = (depthPercent: number): string[] => {
  const docHeight = document.documentElement.scrollHeight;
  const cutoff = (depthPercent / 100) * docHeight;
  const blocks = document.querySelectorAll<HTMLElement>('[data-scroll-block]');
  const result: string[] = [];

  for (const block of blocks) {
    const blockTop = block.getBoundingClientRect().top + window.scrollY;
    if (blockTop < cutoff) {
      const name = block.dataset.scrollBlock;
      if (name) result.push(name);
    }
  }

  return result;
};

export function useMainPageScroll() {
  const trackedDepths = new Set<number>();

  const handleScroll = () => {
    const percent = getScrollDepthPercent();

    for (const depth of SCROLL_DEPTHS) {
      if (percent >= depth && !trackedDepths.has(depth)) {
        trackedDepths.add(depth);
        analyticsEventsLib.mainScroll({
          scroll_depth: depth,
          scroll_blocks: getScrolledBlocks(depth),
        });
      }
    }
  };

  onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
  });

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll);
  });
}
